var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGame = function SvgGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.968 6.757c4.542-2.343 10.522-2.343 15.064 0a3 3 0 0 1 1.388 1.488c1.559 3.659.751 7.768-1.007 10.726-1.055 1.064-3.692 2.154-5.45-1.314-.937-1.846-3.988-1.846-4.924 0-1.76 3.468-4.396 2.378-5.452 1.314-1.758-2.958-2.566-7.067-1.006-10.726.28-.657.78-1.174 1.387-1.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 13.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M18.5 9.875c-1.59.45-3 1.8-3.75 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9.875c1.59.45 3 1.8 3.75 3"
  }))));
};
export default SvgGame;